import { render, staticRenderFns } from "./closeAccount.vue?vue&type=template&id=2858a929"
import script from "./closeAccount.vue?vue&type=script&lang=js"
export * from "./closeAccount.vue?vue&type=script&lang=js"
import style0 from "./closeAccount.vue?vue&type=style&index=0&id=2858a929&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports